var id = 0;
class UserMix {
    constructor() {
        this.id = id++;
        this.name = undefined;
        this.tracks = [];
        this.bpm = undefined;
    }

    deleteTrack(sequence) {
        let id = this.tracks.indexOf(sequence);
        this.tracks.splice(id, 1);
    }

    fromJson(json) {
        if (json === undefined) {
            return undefined;
        }

        if ('name' in json) {
            this.name = json.name;
        }

        if ('tracks' in json) {
            this.tracks = json.tracks;
        }

        if ('bpm' in json) {
            this.bpm = json.bpm;
        }

        if ('id' in json) {
            this.id = json.id;
        }

        return this;
    }

    getJson(includeId=true) {
        let json = {
            name: this.name,
            tracks: this.tracks,
            bpm: this.bpm,
        };

        if (includeId) {
            json.id = this.id;
        }

        return json;
    }
}

export default UserMix;
